// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyD_nQkUnuBn9m5dn0W8z6QPdIanGIq0qRM',
    authDomain: 'mitter-delivery-dev.firebaseapp.com',
    projectId: 'mitter-delivery-dev',
    storageBucket: 'mitter-delivery-dev.firebasestorage.app',
    messagingSenderId: '832143879150',
    appId: '1:832143879150:web:fd9cc8bebbcc1294dd7cff'
  },
  onesignal: {
    // App "Mitter Comercio Dev" de la organizacion Mitter, con el service account de
    // mitter-delivery-dev cargado en FCM. Publico: puede ir en el bundle.
    appId: 'b507c164-2867-4e29-86ca-bbe860ef7142',
    // Sender de FCM del proyecto nuevo; lo pide startInit() de OneSignal 2.x.
    googleProjectNumber: '832143879150',
    // SEGURIDAD: el REST Key es un secreto de servidor y no puede viajar en el
    // bundle. Va en una Cloud Function. Se deja vacio a proposito.
    restKey: ''
  },
  general: {
    symbol: '$',
    code: 'USD'
  },
  // El dominio de la vitrina de este ambiente: el enlace que el comercio comparte
  // (`tienda.mitter.app/<slug>` en prod, `tienda-dev` en develop y en local).
  storefrontHost: 'tienda-dev.mitter.app'

  // Mapas: a proposito no hay nada aca, ni siquiera un respaldo. Las teselas, las
  // direcciones y las rutas las decide el servidor (`geoConfig` y las demas callables
  // `geo*`, con `GEO_PROVIDER`). Ver `GeoService.tileConfig()` y `docs/MAPAS-OSM.md` del
  // workspace.
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
